export default __webpack_public_path__ + "static/media/cinema.6536c271.jpg";